import { TransportUnitDTO } from '@/clients/booking'
import { getIconForTransportMode } from '@/utils/shipments'

import { formatEquipment } from './formatEquipment'
import { fclOverviewCargoString, lclOverviewCargoString } from './getOverviewCargoString'
import { OverviewItem } from '../domain/overviewItem'

export const expandInProgressStatus = (values: string[]): string[] =>
  values.flatMap((v) => (v === 'inProgress' ? ['new', 'active'] : [v]))

export const getOverviewItemIcon = (overviewItem: OverviewItem) => {
  return overviewItem.type === 'booking' ? 'Document' : getIconForTransportMode(overviewItem.transportMode)
}

export const getOverviewItemCargoDetails = (overviewItem: OverviewItem): string => {
  if (overviewItem.type === 'shipment') {
    return overviewItem.transportType === 'fcl'
      ? fclOverviewCargoString(overviewItem.houseCargos)
      : lclOverviewCargoString(overviewItem.houseCargos)
  }

  return formatEquipment(overviewItem.transportType, overviewItem.cargo as TransportUnitDTO[])
}

export const OVERVIEW_TABLE_COLUMN_LIST = [
  'id',
  'references',
  'state',
  'origin',
  'pol',
  'pod',
  'destination',
  'etd',
  'eta',
  'delivery',
  'pickupDate',
  'bookingDate',
] as const

export type OverviewColumn = (typeof OVERVIEW_TABLE_COLUMN_LIST)[number]

export const OverviewColumnFilterKey = {
  id: 'id',
  references: 'references',
  state: 'state',
  origin: 'origin',
  pol: 'portOfLoading',
  pod: 'portOfDischarge',
  destination: 'destination',
  eta: 'timeOfArrival',
  etd: 'timeOfDeparture',
  delivery: 'deliveryDate',
  pickupDate: 'pickupDate',
  bookingDate: 'bookedDate',
}

export function getFilterKeyBySortField(field: string): string | undefined {
  return Object.keys(OverviewColumnFilterKey).find(
    (key) => OverviewColumnFilterKey[key as keyof typeof OverviewColumnFilterKey] === field
  )
}
